import { render, staticRenderFns } from "./BlurPurchaseItem.vue?vue&type=template&id=e8267790&"
import script from "./BlurPurchaseItem.vue?vue&type=script&lang=js&"
export * from "./BlurPurchaseItem.vue?vue&type=script&lang=js&"
import style0 from "./BlurPurchaseItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDialog,VIcon,VProgressLinear,VRow})
